import { render, staticRenderFns } from "./echange-retour.vue?vue&type=template&id=267b019a&scoped=true&"
import script from "./echange-retour.vue?vue&type=script&lang=js&"
export * from "./echange-retour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267b019a",
  null
  
)

export default component.exports